import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import BackNextButtons from 'components/BackNextButtons';
import Delivery, {
    getFieldsOfUSADeliveryAddress as getFieldsOfDeliveryAddress
} from 'components/forms/DeliveryAddress/USA';
import Toast from 'components/Toast';
import { useCheckUSAPostal } from 'hooks/useCheckPostal';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';

export const deliveryAddressFormutilFields = getFieldsOfDeliveryAddress('0'); // 这里没有“邮寄地址与居住地址相同”的勾选框但需要取勾选时的字段

/**
 *  非SSN四个中国开户流程 美国邮寄地址页
 */
const DeliveryAddress: FC<ProgressFormProps> = ({ onSubmit }) => {
    const navigate = useNavigate();
    const { checkPostalMatchStateCodeError } = useCheckUSAPostal();

    const handleSubmit = (ev: React.FormEvent) => {
        onSubmit(async () => {
            Toast.loading(true);

            try {
                const deliveryPostalError = await checkPostalMatchStateCodeError(
                    'delivery_postal',
                    'delivery_state_code',
                    'delivery_address_type'
                );

                if (!deliveryPostalError) {
                    navigate('../job');
                }
            } catch (error) {
                Toast.show(error);
            }

            Toast.loading(false);
        }, ev);
    };

    return (
        <form className="open-delivery-address-root" noValidate onSubmit={handleSubmit}>
            <Delivery title={__('U.S. Mailing Address')} isSSN={false} isFourChn isMarsco countryDisabled />
            <BackNextButtons sticky />
        </form>
    );
};

export default withProgressForm({
    id: 'deliveryAddress',
    step: 2,
    basePath: 'open',
    eventParams: {
        exposureEventParams: {
            model: '开户-美国邮寄信息',
            name: '美国邮寄信息-页面曝光'
        },
        submitEventParams: {
            model: '开户-美国邮寄信息',
            name: '美国邮寄信息-点击下一步'
        }
    }
})(DeliveryAddress);
